import styled from 'styled-components'
import { colors } from '../../../theme'

/*
 * Gemeo do modal de components/SaveAnimated — mesmo desenho, mesmas correcoes:
 * overlay que centraliza de verdade (era `display: block`, com a caixa
 * dependendo do fluxo), largura fixa (era `width: 35%`) e o `h1` que estava em
 * `color: black`, ou seja, preto sobre o cartao escuro — invisivel.
 */

export const ContainerSheetsStatusStyle = styled.button`
  position: fixed;
  inset: 0;
  z-index: 2001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  border: none;
  background-color: ${colors.overlay};
  backdrop-filter: blur(2px);
  cursor: pointer;
`

export const SheetsStatusStyle = styled.div`
  width: min(380px, 100%);
  background-color: ${colors.surface};
  border: 1px solid ${colors.grey300};
  border-radius: 16px;
  padding: 32px 28px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);
  text-align: center;

  svg {
    width: 52px;
    height: 52px;
  }

  h1 {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
    margin-top: 16px;
    color: ${colors.grey900};
  }
`

export const Upload = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 10px;
`
